import { Component } from '@angular/core';

@Component({
  templateUrl: './business-list-page.html',
})
/**
 * Business List Page!
 */
export class BusinessListPage {}
